import { render, staticRenderFns } from "./RadioNew.vue?vue&type=template&id=2bc3055d&scoped=true&"
import script from "./RadioNew.vue?vue&type=script&lang=js&"
export * from "./RadioNew.vue?vue&type=script&lang=js&"
import style0 from "./RadioNew.vue?vue&type=style&index=0&id=2bc3055d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3055d",
  null
  
)

export default component.exports